import { render, staticRenderFns } from "./HealthAssessmentSurvey.vue?vue&type=template&id=4d119fae&"
import script from "./HealthAssessmentSurvey.vue?vue&type=script&lang=js&"
export * from "./HealthAssessmentSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports